import { render, staticRenderFns } from "./TfxqMembershipCard.vue?vue&type=template&id=478e05de&scoped=true&"
import script from "./TfxqMembershipCard.vue?vue&type=script&lang=js&"
export * from "./TfxqMembershipCard.vue?vue&type=script&lang=js&"
import style0 from "./TfxqMembershipCard.vue?vue&type=style&index=0&id=478e05de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e05de",
  null
  
)

export default component.exports